<div class="column">
    <div  id="txt_{{text.id}}"  [innerHTML]="text?.text"></div>
</div>


